export enum FeatureRouteEnum {
  AUTH = 'auth',
  PROFILE = 'profile',
  OLYMPIAD = 'olympiad',
  SIGN_IN_REDIRECT = 'signed-in-redirect',
  APPLICATIONS = 'applications',
  SPECIAL_USERS = 'special-users',
  APPELLATION = 'appellation',
  APPLICATION_GROUP = 'application-group',
  OLYMPIAD_TEAM = 'olympiad-team',
  STEP_TO_INVENTION = 'step-to-invention',
  RESULTS = 'results',
  DEMO_TESTS = 'demo-tests',
  LICENSE_STUDENT = 'license-student',
}
